<template lang="html">
  <section class="data-engine-where-group" :id="id">
    <div class="group">
      <div class="clauses">
        <draggable-item
          ref="draggables"
          v-for="(clause, index) in whereClauses"
          :key="clause.id"
          :info="clause"
          :id="'draggable-item-' + clause.id"
          @on-draggable-drag-start="onDraggableStart"
          @on-draggable-drag-enter="onDraggableEnter"
        >
          <data-engine-where-group
            v-if="clause.id.indexOf('group-') === 0"
            :ref="clause.id"
            :id="clause.id"
            :info="clause"
            :fields="fields"
            :data-element="dataElement"
            :all-des="allDes"
            @on-draggable-item-drop="onDraggableItemDrop"
            @on-where-clause-update="onWhereClauseUpdate"
          />

          <section
            :ref="'clause-item-' + clause.id"
            class="clauses-container"
            v-if="clause.id.indexOf('group-') === -1"
          >
            <search-box
              class="left-input"
              :id="'clause-search-' + clause.id"
              :box-type="'deEditModal'"
              :has-icon="true"
              :list="fields"
              :is-first-input="true"
              :value="clause.field ? clause.field : null"
              @on-search-box-item-selected="onClauseKeySelected"
            />

            <b-form-select
              class="form-select"
              v-model="clause.type"
              :options="getOpsFromType(clause.field)"
              :id="clause.id"
              @change="onOperatorChange(clause)"
              size="sm"
            />

            <div class="right-input" :ref="'clause-right-dd-' + clause.id">
              <search-box v-if="!clause.field" />
              <div v-else>
                <div
                  class="expression-input"
                  v-if="clause.type && clause.type.value === 'between'"
                >
                  <expressions
                    :id="'clause-id-' + clause.id + '-startValue'"
                    :data-elements="desClone"
                    :selected-source="dataElement"
                    :data-type="getContextDataType(clause)"
                    :initial-expression="clause.startValue"
                    :is-global="isGlobal"
                    :content-type="appType"
                    :is-list-expression="isListExpressions(clause)"
                    @on-expression-field-valid="onValidBetweenExpressions"
                  />

                  <expressions
                    :id="'clause-id-' + clause.id + '-endValue'"
                    :data-elements="desClone"
                    :selected-source="dataElement"
                    :data-type="getContextDataType(clause)"
                    :initial-expression="clause.endValue"
                    :is-global="isGlobal"
                    :content-type="appType"
                    :is-list-expression="isListExpressions(clause)"
                    @on-expression-field-valid="onValidBetweenExpressions"
                  />
                </div>
                <div v-else-if="clause.type && clause.type.value === 'in'">
                  <expressions
                    :id="'clause-id-' + clause.id"
                    :data-elements="desClone"
                    :selected-source="dataElement"
                    :data-type="getContextDataType(clause)"
                    :initial-expression="clause.values"
                    :is-global="isGlobal"
                    :content-type="appType"
                    :is-list-expression="isListExpressions(clause)"
                    @on-expression-field-valid="onValidInExpression"
                  />
                </div>
                <div
                  v-else-if="
                    clause.type &&
                      (clause.type.value === 'is_null' ||
                        clause.type.value === 'is_not_null')
                  "
                ></div>
                <div v-else>
                  <expressions
                    :id="'clause-id-' + clause.id"
                    :data-elements="desClone"
                    :selected-source="dataElement"
                    :data-type="getContextDataType(clause)"
                    :initial-expression="clause.value"
                    :is-global="isGlobal"
                    :content-type="appType"
                    :is-list-expression="isListExpressions(clause)"
                    @on-expression-field-valid="onValidExpression"
                  />
                </div>
              </div>

              <svg
                class="m-close-selection-icon"
                tabindex="0"
                @keydown.enter.stop="displayModalDeleteClause(clause.id)"
                @click="displayModalDeleteClause(clause.id)"
              >
                <use
                  xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#close"
                ></use>
              </svg>
            </div>
          </section>
          <div class="clause_type">
            <draggable-item
              class="dropzone_item"
              :info="clause"
              @on-draggable-drop="onDropzoneDrop"
              @on-draggable-drag-enter="onDropzoneEnter"
              @on-draggable-drag-leave="onDropzoneLeave"
            >
              <span
                v-if="
                  whereClauses.length > 1 && index !== whereClauses.length - 1
                "
                >{{ clauseType.text }}</span
              >
            </draggable-item>
          </div>
        </draggable-item>
        <!-- dropzone when group has no clause -->
        <draggable-item
          v-if="displayDropzone"
          @on-draggable-drop="onDropzoneDrop"
          @on-draggable-drag-enter="onDropzoneEnter"
          @on-draggable-drag-leave="onDropzoneLeave"
        >
        </draggable-item>
      </div>
      <div class="group-btns">
        <div class="add-btns">
          <button
            class="m-btn_icon m-button neutral"
            @click="addWhereClause(id)"
          >
            <svg>
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#new"
              ></use>
            </svg>
            {{ $t("addWhereClause") }}
          </button>
          <button
            v-if="shouldShowAddGroup"
            class="m-btn_icon m-button neutral"
            @click="addGroup"
          >
            <svg>
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#new"
              ></use>
            </svg>
            {{ $t("addGroup") }}
          </button>
        </div>

        <div class="delete-btn">
          <button
            class="m-btn_icon delete m-button neutral"
            @click="displayModalDeleteGroup"
          >
            <svg>
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete"
              ></use>
            </svg>
            {{ $t("delete") }}
          </button>
        </div>
      </div>

      <div class="group-header">
        <div class="row-icon">
          <div v-if="showDragLines">
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </div>
        <div class="and-or-btns slds-button-group">
          <div v-if="showDragLines">
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <button
            class="slds-button"
            :class="
              clauseType.value === types.AND.value
                ? 'm-button brand'
                : 'm-button neutral'
            "
            @click="updateClause(types.AND)"
          >
            {{ $t("and") }}
          </button>
          <button
            class="slds-button"
            :class="
              clauseType.value === types.OR.value
                ? 'm-button brand'
                : 'm-button neutral'
            "
            @click="updateClause(types.OR)"
          >
            {{ $t("or") }}
          </button>
        </div>
      </div>
    </div>
    <simple-modal
      ref="simpleModal"
      :show="displaySimpleModal"
      :message="getMessageText(messages.ARE_YOU_SURE)"
      :cancel-text="getMessageText(messages.CANCEL)"
      :ok-text="getMessageText(messages.OK)"
      @on-simple-modal-cancel="onCancelDeleteItem"
      @on-simple-modal-ok="onConfirmDeleteItem"
    />
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import store from "@/store";
  import sortBy from "lodash/sortBy";
  import moveImg from "@/views/drag-drop-pages/img/move_img.png";
  import { GROUP_CLAUSE_TYPE, STYLE } from "@/static/global-variables";
  import draggableHelper from "@/draggables/helper";
  import DraggableItem from "@/views/drag-drop-pages/components/list/DraggableItem";
  import SearchBox from "@/components/SearchBox";
  import DataEngineWhereGroup from "@/components/queries/crm-data-engine/DataEngineWhereGroup";
  import SimpleModal from "@/views/drag-drop-pages/components/modal/SimpleModal";
  import utils from "@/utils";
  import Expressions from "@/components/Expressions";
  const CLAUSE_ID_PREFIX = "clause-id-";

  export default  {
    name: "data-engine-where-group",
    components: {
      SearchBox,
      DraggableItem,
      DataEngineWhereGroup,
      SimpleModal,
      Expressions
    },
    props: {
      id: {
        type: String
      },
      groupPrefix: {
        type: String,
        default: "group-"
      },
      info: {
        type: Object
      },
      fields: {
        type: Array
      },
      where: {
        type: Object,
        default: function() {
          return {};
        }
      },
      dataElement: {
        type: Object
      },
      allDes: {
        type: Object
      },
      appType: {
        type: String
      }
    },
    watch: {
      where: {
        handler() {
          this.whereClauses = [];
          this.setExistingClauses(this.where);
        },
        immediate: true
      },
      whereClauses: {
        handler() {
          this.$emit("on-where-clause-update", {});
        },
        deep: true
      },
      clauseType: {
        handler() {
          this.$emit("on-where-clause-update", {});
        }
      }
    },
    mounted () {
      this.img = document.createElement("img");
      this.img.src = moveImg;

      this.showDragLines = this.id !== this.groupPrefix + "1";
      // when serializing the group only add the following props
      this.allowProps = ["id", "groupPrefix", "info"];
      this.opsForAll = utils.getOpsForAll(this.operators);
      this.opsForComparable = utils.getOpsForComparable(this.operators);
      this.opsForStringList = utils.getOpsForStringList(this.operators);

      this.desClone = JSON.parse(JSON.stringify(this.allDes));
      delete this.desClone[this.dataElement.id];
    },
    computed: {
      messages() {
        return store.state.messages;
      },
      displayDropzone() {
        return !this.whereClauses.length;
      },
      operators() {
        return [
          {
            text: this.$t("in"),
            value: {
              text: this.$t("in"),
              value: "in"
            }
          },
          {
            text: this.$t("equal"),
            value: {
              text: this.$t("equal"),
              value: "equal"
            }
          },
          {
            text: this.$t("notEqual"),
            value: {
              text: this.$t("notEqual"),
              value: "not_equal"
            }
          },
          {
            text: this.$t("gte"),
            value: {
              text: this.$t("gte"),
              value: "greater_than_or_equal"
            }
          },
          {
            text: this.$t("lte"),
            value: {
              text: this.$t("lte"),
              value: "less_than_or_equal"
            }
          },
          {
            text: this.$t("gt"),
            value: {
              text: this.$t("gt"),
              value: "greater_than"
            }
          },
          {
            text: this.$t("lt"),
            value: {
              text: this.$t("lt"),
              value: "less_than"
            }
          },
          {
            text: this.$t("isNullOperator"),
            value: {
              text: this.$t("isNullOperator"),
              value: "is_null"
            }
          },
          {
            text: this.$t("isNotNullOperator"),
            value: {
              text: this.$t("isNotNullOperator"),
              value: "is_not_null"
            }
          },
          {
            text: this.$t("between"),
            value: {
              text: this.$t("between"),
              value: "between"
            }
          },
        ];
      }
    },
    data () {
      return {
        desClone: null,
        groups: [],
        types: GROUP_CLAUSE_TYPE,
        clauseType: GROUP_CLAUSE_TYPE.AND,
        whereClauses: [],
        showDragLines: true,
        displaySimpleModal: false,
        opsForAll: [],
        opsForComparable: [],
        opsForStringList: [],
        isGlobal: true,
        shouldShowAddGroup: false,
        IN: "in",
        level: 1,
      }
    },
    methods: {
      updateClause(type) {
        this.clauseType = type;
      },
      getOpsFromType(field) {
        let output = this.opsForAll;

        if (field && field.type) {
          if (utils.isComparableType(field.type)) {
            output = output.concat(this.opsForComparable);
          }

          if (field.type === "string") {
            output = output.concat(this.opsForStringList);
          }
        }

        return output;
      },
      onClauseKeySelected(val) {
        let clauseKeyId = val.searchBoxId.replace("clause-search-", "");
        this.whereClauses.forEach(field => {
          if (field.id === clauseKeyId) {
            if (val.name) {
              field.field = {
                name: val.name,
                label: val.label,
                type: val.type
              };
            } else {
              field.field = null;
              delete field.type;
              delete field.value;
            }
          }
        });
        // add empty array to trigger watch event since this.$forceUpdate() does not triggers the update
        this.whereClauses = this.whereClauses.concat([]);
      },
      getFieldType(clause) {
        let output;
        if (clause && clause.field) {
          if(clause.type && clause.type.value !== this.IN) {
            output = clause.field.type;
          }
        }
        return output;
      },
      isListExpressions(clause) {
        return clause.type && clause.type.value === this.IN;
      },

      getContextDataType(clause) {
        return clause.field ? clause.field.type : "";
      },

      onOperatorChange(clause) {
        const targetId = `clause-right-dd-${clause.id}`;
        if (clause.type && (clause.type.value === "is null" || clause.type.value === "is not null")) {
          this.$refs[targetId][0].style.visibility = "hidden";
        } else {
          this.$refs[targetId][0].style.visibility = "visible";
        }
      },

      onValidBetweenExpressions(ctx) {
        if (ctx.id.endsWith('-startValue')) {
          const fieldId = ctx.id.replace(CLAUSE_ID_PREFIX, "").replace('-startValue', "");
          const field = this.whereClauses.find(e => e.id === fieldId);
          delete field.startValue;
          if (ctx.status) {
            field.startValue = ctx.confExpression;
          }
        }
        if (ctx.id.endsWith('-endValue')) {
          const fieldId = ctx.id.replace(CLAUSE_ID_PREFIX, "").replace('-endValue', "");
          const field = this.whereClauses.find(e => e.id === fieldId);
          delete field.endValue;
          if (ctx.status) {
            field.endValue = ctx.confExpression;
          }
        }
        this.whereClauses = this.whereClauses.concat([]);
      },

      onValidInExpression(ctx) {
        const fieldId = ctx.id.replace(CLAUSE_ID_PREFIX, "");
        const field = this.whereClauses.find(e => e.id === fieldId);
        delete field.values;
        if (ctx.status) {
          field.values = ctx.confExpression;
        }
        // add empty array to trigger watch event since this.$forceUpdate() does not triggers the update
        this.whereClauses = this.whereClauses.concat([]);
      },

      onValidExpression(ctx) {
        const fieldId = ctx.id.replace(CLAUSE_ID_PREFIX, "");
        const field = this.whereClauses.find(e => e.id === fieldId);
        delete field.value;
        if (ctx.status) {
          field.value = ctx.confExpression;
        }
        // add empty array to trigger watch event since this.$forceUpdate() does not triggers the update
        this.whereClauses = this.whereClauses.concat([]);
      },
      deleteClause(id) {
        this.$nextTick(() => {
          this.whereClauses = this.whereClauses.filter(clause => {
            return clause.id !== id;
          });
        });
      },
      addWhereClause(id) {
        const rId = this.getNextRowId();
        const clause = {
          id: uuidv4(),
          groupId: id,
          rowId: rId
        };
        this.whereClauses.push(clause);
      },
      moveWhereClause(clause) {
        clause.groupId = this.id;
        this.whereClauses.push(clause);
        this.whereClauses = sortBy(this.whereClauses, "rowId", "asc");
        this.whereClauses.forEach((e, i) => e.rowId = i);
      },
      getNextGroupId() {
        const ids = this.groups.map(e => Number(e.split("-").pop()));
        ids.sort((a, b) => a - b);
        let groupId = this.id + "-1";
        if(ids.length) {
          const next = Number(ids.pop()) + 1;
          groupId = this.id + "-" + next;
        }
        return groupId;
      },
      getNextRowId() {
        const rowIds = this.whereClauses.map(e => e.rowId);
        rowIds.sort((a, b) => a - b);
        return rowIds.length? (rowIds.pop() + 1) : 0;
      },
      addGroup() {
        const groupId = this.getNextGroupId();
        const rId = this.getNextRowId();
        let group = {
          id: groupId,
          groupId: this.id,
          rowId: rId
        };
        this.whereClauses.push(group);
        this.groups.push(groupId);
        return groupId;
      },
      moveGroup(from, group, serialized) {
        const parent = group.$parent.$parent;
        const groupId = this.getNextGroupId();
        from.id = groupId;
        from.groupId = this.id;
        this.whereClauses.push(from);
        this.groups.push(groupId);
        this.whereClauses = sortBy(this.whereClauses, "rowId", "asc");
        this.whereClauses.forEach((e, i) => e.rowId = i);
        this.$nextTick(() => {
          this.$refs[from.id][0].setSerializedData(serialized);
          parent.deleteClause(group.id);
          parent.deleteClause(groupId);
        });
      },
      setSerializedData(serialized) {
        const data = serialized.data;
        for(const clause of data.whereClauses) {
          this.moveWhereClause(clause);
        }
        this.clauseType = data.clauseType;
        this.groups = data.groups;
        this.$nextTick(() => {
          for(const [id, groupData] of Object.entries(data.groupData)) {
            this.$refs[id][0].setSerializedData(groupData);
          }
        });
      },
      // function to populate existing where clauses
      setExistingClauses(where) {
        if(where && where.type) {
          const map = new Map();
          this.clauseType = where.type === "all_of" ? GROUP_CLAUSE_TYPE.AND : GROUP_CLAUSE_TYPE.OR;
          if(where.conditions) {
            for(const clause of where.conditions) {
              if(clause.id) {
                clause.field = this.fields.find( individualField => {
                  return individualField.name === clause.field;
                })
                clause.rowId = this.whereClauses.length;
                clause.type = this.operators.find( operator => {
                  return operator.value.value === clause.type;
                  }
                ).value;
                this.moveWhereClause(clause);
              } else {
                // this is a group
                map.set(this.addGroup(), clause);
              }
            }
          }
          this.$nextTick(() => {
            if(this.groups.length) {
              for(const groupId of this.groups) {
                const group = this.$refs[groupId][0];
                if(group) {
                  group.setExistingClauses(map.get(groupId));
                }
              }
            }
          });
        }
      },
      onCancelDeleteItem() {
        this.displaySimpleModal = false;
      },
      onConfirmDeleteItem() {
        this.displaySimpleModal = false;
        if(this.tmpClauseId) {
          this.deleteClause(this.tmpClauseId);
        } else {
          this.deleteGroup();
        }
        // reset
        this.tmpClauseId = null;
      },
      deleteGroup() {
        this.whereClauses = [];
        this.groups = [];
        this.clauseType = GROUP_CLAUSE_TYPE.AND;
        const parent = this.$parent.$parent;
        if(parent.deleteClause) {
          // remove where group
          parent.deleteClause(this.id);
        }
      },
      displayModalDeleteGroup() {
        this.tmpClauseId = null;
        this.displaySimpleModal = true;
      },
      displayModalDeleteClause(id) {
        this.tmpClauseId = id;
        this.displaySimpleModal = true;
      },
      // Method to parse clauses into
      // formatted json to submit to data local store
      getWhereClauses() {
        const dataEngineType = this.clauseType.value === "and" ? "all_of" : "any_of";

        let formattedWhere = {
          type: dataEngineType,
          conditions: []
        };
        this.whereClauses.forEach(item => {
          if(item.id.indexOf(this.groupPrefix) === 0) {
            // this is a group
            const group = this.$refs[item.id] ? this.$refs[item.id][0] : null;
            if(group) {
              formattedWhere.conditions.push(group.getWhereClauses());
            } else {
              formattedWhere.conditions.push({});
            }
          } else {
            switch (item.type && item.type.value) {
              case "in":
                formattedWhere.conditions.push({
                  id: item.id,
                  type: item.type && item.type.value,
                  field: item.field && item.field.name,
                  values: item.values
                });
                break;
              case "between":
                formattedWhere.conditions.push({
                  id: item.id,
                  type: item.type && item.type.value,
                  field: item.field && item.field.name,
                  startValue: item.startValue,
                  endValue: item.endValue
                });
                break;
              case "is_null":
                formattedWhere.conditions.push({
                  id: item.id,
                  type: item.type && item.type.value,
                  field: item.field && item.field.name,
                });
                break;
              case "is_not_null":
                formattedWhere.conditions.push({
                  id: item.id,
                  type: item.type && item.type.value,
                  field: item.field && item.field.name,
                });
                break;
              default:
                formattedWhere.conditions.push({
                  id: item.id,
                  type: item.type && item.type.value,
                  field: item.field && item.field.name,
                  value: item.value
                });
            }
          }
        });
        return formattedWhere;
      },

      onDraggableStart(ev) {
        draggableHelper.data = ev.data.info;
        draggableHelper.fromRef = ev.componentInstance || this;
        ev.dataTransfer.setDragImage(this.img, 10, 10);
        if(ev.data.info.id.indexOf(this.groupPrefix) === 0) {
          // moving group, get meta data
          draggableHelper.serialized = draggableHelper.fromRef.getGroupRawMeta();
        }
      },
      removeDropOverEffect() {
        if(this.$refs.draggables) {
          for(const component of this.$refs.draggables) {
            component.$el.classList.remove(STYLE.UI_ACTION.DROP_OVER);
            if(component.id.indexOf(this.groupPrefix) > -1) {
              const group = component.$slots.default[0].componentInstance;
              if(group) {
                group.removeDropOverEffect();
              }
            }
          }
        }
      },
      onDraggableEnter(ev) {
        const from = draggableHelper.data;
        if(from) {
          const to = ev.data.info;
          if(to && from.id !== to.id) {
            for(const component of this.$refs.draggables) {
              component.$el.classList.remove(STYLE.UI_ACTION.DROP_OVER);
              if(component.id === "draggable-item-" + to.id && component.id.indexOf(this.groupPrefix) === -1) {
                component.$el.classList.add(STYLE.UI_ACTION.DROP_OVER);
              }
            }
          }
        }
      },
      onDraggableItemDrop() {
        // emit event to parent, until it gets to the root
        this.$emit("on-draggable-item-drop", {});
      },

      // events for dropzone between clauses and groups
      onDropzoneDrop(ev) {
        const from = draggableHelper.data;
        if(from) {
          if(from.id.indexOf(this.groupPrefix) === -1) {
            if(this.id === from.groupId) {
              // moving clause to same group
              const to = ev.data.info;
              from.rowId = to? to.rowId + 0.1: this.getNextRowId(); // to place it right after
              this.whereClauses = sortBy(this.whereClauses, "rowId", "asc");
              this.whereClauses.forEach((e, i) => e.rowId = i);
            } else {
              //moving class to other group
              const to = ev.data.info;
              from.groupId = this.id;
              from.rowId = to? to.rowId + 0.1: this.getNextRowId(); // to place it right after
              this.whereClauses.push(from);
              this.whereClauses = sortBy(this.whereClauses, "rowId", "asc");
              this.whereClauses.forEach((e, i) => e.rowId = i);
              draggableHelper.fromRef.deleteClause(from.id);
            }
          } else {
            // moving a group
            const to = ev.data.info;
            from.rowId = to? to.rowId + 0.1: this.getNextRowId(); // to place it right after
            if(from.groupId !== this.id) {
              this.moveGroup(from, draggableHelper.fromRef, draggableHelper.serialized);
            } else {
              this.whereClauses = sortBy(this.whereClauses, "rowId", "asc");
            }
          }
          this.$nextTick(() => {
            this.$emit("on-draggable-item-drop", {});
          });
        }
        this.resetDropzone(ev);
      },
      onDropzoneEnter(ev) {
        ev.target.classList.add(STYLE.UI_ACTION.DROP_OVER);
      },
      onDropzoneLeave(ev) {
        this.resetDropzone(ev);
      },
      resetDropzone(ev) {
        ev.target.classList.remove(STYLE.UI_ACTION.DROP_OVER);
      },
      // up to here

      onWhereClauseUpdate() {
        // emit to parent
        this.$emit("on-where-clause-update", {});
      },
      // method to get group metadata to move this group to another location
      getGroupRawMeta() {
        const componentData = {
          props: {},
          data: {
            groups: JSON.parse(JSON.stringify(this.groups)),
            clauseType: this.clauseType,
            whereClauses: JSON.parse(JSON.stringify(this.whereClauses)),
            groupData: []
          }
        };
        // only add allowed props when serializing
        for (const key of Object.keys(this.$options.props)) {
          if(this.allowProps.includes(key)) {
            componentData.props[key] = this[key];
          }
        }
        const groupData = {};
        for(const clause of this.whereClauses) {
          if(clause.id.indexOf(this.groupPrefix) === 0) {
            groupData[clause.id] = this.$refs[clause.id][0].getGroupRawMeta();
          }
        }
        componentData.data.groupData = groupData;
        return componentData;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .data-engine-where-group {
    border: 1px solid $box-border-color;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .group {
      position: relative;
      box-sizing: border-box;
      min-height: 90px;
      padding: 10px;
      .clauses {
        padding: 30px 0 8px;
        min-height: 100px;
        .clauses-container {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          background-color: #ffffff;
          margin: 0;
          .left-input {
            flex-basis: 40%;
          }
          .right-input {
            display: flex;
            flex-basis: 50%;
          }
          .expression-input {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }
          .m-close-selection-icon {
            align-self: center;
            margin: 0.5rem;
            width: 15px;
            height: 15px;
            fill: #706e6b;
            cursor: pointer;
          }
          .form-select {
            min-width: 7rem;
            flex-basis: 20%;
          }
        }
      }
      .group-header {
        position: absolute;
        top: -2px;
        left: 0;
        right: 0;
        display: flex;
        box-sizing: border-box;
        padding: 5px 5px 0;
        .row-icon {
          box-sizing: border-box;
          flex-grow: 1;
        }
        .line {
          background-color: #efedec;
          height: 3px;
          width: 100%;
          margin-bottom: 1px;
        }
        & .and-or-btns {
          button {
            height: 25px;
          }
        }
      }
      .group-btns {
        display: grid;
        grid-template-columns: 5fr 1fr;
        .add-btns {
          button {
            margin-right: 8px;
          }
        }
      }

      button {
        font-size: 11px;
      }
      .delete-btn {
        justify-self: end;
      }

      .m-btn_icon {
        justify-self: end;
        cursor: pointer;
        padding-left: 10px;
        &.delete {
          fill: #c23934;
          white-space: nowrap;
        }
        svg {
          height: 15px;
          width: 15px;
          vertical-align: sub;
        }
      }
    }
    .clause_type {
      min-height: 20px;
    }
    .draggable-item {
      min-height: 50px;
    }
    .drop-over {
      background-color: peachpuff;
    }
    .dropzone_item {
      min-height: 20px;
      padding: 5px;
    }
  }
</style>
